import type { ILocalizationService } from "@emanprague/shared-services";
import { bound } from "@frui.ts/helpers";
import { BusyWatcher, ScreenBase, watchBusy } from "@frui.ts/screens";
import { attachAutomaticValidator, hasVisibleErrors, validate } from "@frui.ts/validation";
import ResetPassword, { ResetPasswordValidationRules } from "entities/resetPassword";
import { action, observable, runInAction } from "mobx";
import type LoginRepository from "repositories/loginRepository";

type StepName = "step1" | "step2";

export default class ForgottenPasswordViewModel extends ScreenBase {
  static navigationName = "forgottenPassword";
  navigationName = ForgottenPasswordViewModel.navigationName;
  busyWatcher = new BusyWatcher();
  @observable data: ResetPassword;
  @observable currentStep: StepName = "step1";
  @observable successMessage: string;
  @observable sapNotice: string;

  constructor(
    public localization: ILocalizationService,
    private loginRepository: LoginRepository
  ) {
    super();

    this.name = this.translate("title");

    this.data = { email: "", sapNotice: "" };
    attachAutomaticValidator(this.data, ResetPasswordValidationRules);
  }

  @bound translate(key: string) {
    return this.localization.translateGeneral(`profile.forgotten_password.${key}`);
  }

  @bound translateGeneral(key: string) {
    return this.localization.translateGeneral(`general.${key}`);
  }

  get canContinue() {
    return !hasVisibleErrors(this.data);
  }

  @action.bound
  @watchBusy
  async continue() {
    if (validate(this.data) && this.data.email) {
      const response = await this.loginRepository.resetPassword(this.data);
      if (response.success) {
        runInAction(() => {
          this.successMessage = this.translate("message_sent").replace("%email%", this.data.email);
          this.sapNotice = response.payload.sapNotice;
          this.currentStep = "step2";
        });
      }
    }
  }
}
